export default "__VITE_ASSET__DplTs6OZ__"